import { Injectable } from '@angular/core';
import { storageKeys, appApiResources } from '../app.constants';
import { CommonService } from './common.service';
import { TranslateService } from '@ngx-translate/core';
import { HttpWrapperService, HttpInputData } from './core/http/http-wrapper.service';
import { HttpParams } from '@angular/common/http';
import { AppStateService } from './init/app-state.service';
import { AlertServiceService } from '../alert-service.service';
import { AlertController, Platform } from '@ionic/angular/standalone';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { AnalyticsService, GA4_EVENTS } from './core/analytics/analytics.service';
@Injectable({
  providedIn: 'root'
})
export class BuyCertificatesService {
  cartItems = [];
  selectedCertificate: any;

  constructor(
    private commonServ: CommonService,
    private translate: TranslateService,
    private httpWrapper: HttpWrapperService,
    public appState: AppStateService,
    private alertService: AlertServiceService,
    private alertCtrl: AlertController,
    private router: Router,
    private platform: Platform,
    private analyticsService: AnalyticsService
  ) { }

  addCertificateToCart(selectedCertificate) {
    this.loadCartItems();
    let cartItem = {
      certificate: selectedCertificate,
      numberOfCertificate: 1
    };
    if (this.cartItems.length) {
      let samePGcertificate = 0;
      for (let i = 0; i < this.cartItems.length; i++) {
        if (this.cartItems[i].certificate.sfdcData.paymentGatewaySfid === selectedCertificate.sfdcData.paymentGatewaySfid) {
          samePGcertificate += 1;
        }
      }
      if (samePGcertificate !== this.cartItems.length) {
        // this.translate.get('buyCertificate.multiPGmessage').subscribe(
        //   (multiPGmessage) => {
        //     this.translate.get('toastMsg.ok').subscribe(
        //       async (ok) => {
        //         const multiPGalert = await this.alertCtrl.create({
        //           backdropDismiss: false,
        //           message: multiPGmessage,
        //           buttons: [ok],
        //           mode: "ios",
        //           cssClass: "alertCustomCss"
        //         });
        //         multiPGalert.present();
        //       }
        //     )
        //   }
        // )

        //subscibe and unsubscribe 
        const multiPGmessage = this.translate.instant(
          "buyCertificate.multiPGmessage"
        );
        const ok = this.translate.instant("toastMsg.ok");

        this.alertCtrl
          .create({
            backdropDismiss: false,
            message: multiPGmessage,
            buttons: [ok],
            mode: "ios",
            cssClass: "alertCustomCss",
          })
          .then((alert) => alert.present());
        return;
      }
    }
    if (this.cartItems) {
      let count = 0;
      for (let i = 0; i < this.cartItems.length; i++) {
        if (this.cartItems[i].certificate.sfdcData.aemIdentifier === selectedCertificate.sfdcData.aemIdentifier) {
          count += 1;
          this.cartItems[i].numberOfCertificate += 1;
        }
      }
      if (!count) {
        this.cartItems.push(cartItem);
      }
    } else {
      this.cartItems.push(cartItem);
    }
    if (this.platform.is("cordova")) {
      const params = {
        currency: selectedCertificate?.sfdcData?.price?.currency,
        value: selectedCertificate?.sfdcData?.price?.amount,
        items: this.cartItems
      };
      this.analyticsService.logCustomFirebaseEvent(GA4_EVENTS.ADD_TO_CART, params)
    }
    // console.log('cartItems buyCertificate service ====>>>', this.cartItems);
    this.router.navigate(['cart']);
    this.appState.saveCartDetails(this.cartItems)
  }

  async loadCartItems() {
    const appData = this.appState.getAppData();
    // console.log('AppStateData ==>', appData);
    if (appData && appData.cartDetails) {
      this.cartItems = appData.cartDetails;
    } else {
      this.cartItems = [];
    }
  }

  async updateCartItem(certificate, index) {
    //console.log('quantity =====>>>', certificate.numberOfCertificate, 'index=====>>>>', index);
    if (certificate.numberOfCertificate === 1) {
      this.cartItems.splice(index, 1);
    } else {
      this.cartItems[index].numberOfCertificate = certificate.numberOfCertificate;
    }
    //console.log('cart items ======>>>>>', this.cartItems)
    this.appState.saveCartDetails(this.cartItems);
  }

  // reafctored code non-blocked task
buyCertificate(data, membershipNumber) {
    this.commonServ.presentLoader(this.translate.instant('loader.fetchData'));
    const options = new HttpInputData();
    const httpParams = new HttpParams();
    options.params = httpParams;
    data['source'] = storageKeys.source;
    return this.httpWrapper.post(appApiResources.buyCertificate + membershipNumber, data, options)
        .then((res) => {
            this.commonServ.dismissLoader();
            //console.log('response from buy certificate api ======>>>>>>', res);
            return res;
        })
        .catch((error) => {
            this.alertService.errorAlertController(error);
        })
        .finally(() => {
            this.commonServ.dismissLoader();
        });
}

 // reafctored code non-blocked task
validatePromocode(data) {
    this.commonServ.presentLoader(this.translate.instant('loader.fetchData'));
    const options = new HttpInputData();
    const httpParams = new HttpParams();
    options.params = httpParams;
    return this.httpWrapper.post(appApiResources.validateBuyPromocodeApi, data, options)
        .then((res) => {
            this.commonServ.dismissLoader();
            //console.log('response from buy Promocode api ======>>>>>>', res);
            return res;
        })
        .catch((error) => {
            this.alertService.errorAlertController(error);
        })
        .finally(() => {
            this.commonServ.dismissLoader();
        });
}

}
